import VueResource from 'vue-resource'
import Vue from 'vue'
import router from '../router'
import store from '../store'
import {alert} from '../utils/dlg'
import {
  CHECK_AUTHENTICATION,
  OBTAIN_AUTHENTICATION,
  CLEAR_AUTHENTICATION,
  RETRIEVE_ACCOUNT
} from '../store/mutation-types'
import refreshToken from './auth/refresh'
import {getAuthorizeUrl, isWechatBrowser} from '../utils/wx'

function getCode (body) {
  // 针对文件上传时，响应数据类型为ArrayBuffer的情况
  if (body instanceof ArrayBuffer) {
    let str = String.fromCharCode.apply(null, new Uint8Array(body))
    body = JSON.parse(str)
  }
  return body.code
}

let pendingRequests = []

export default () => {
  Vue.use(VueResource)
  store.commit(CHECK_AUTHENTICATION)
  store.commit(RETRIEVE_ACCOUNT)
  Vue.http.interceptors.push(function (request, next) {
    request.headers.set('Authorization', store.state.auth.header)
    // request.headers.set('Accept', 'application/vnd.hx.v2+json')
    next(function (response) {
      if (response.status === 401) {
        if (getCode(response.body) !== 2) { // 不是过期
          logout(false)
          return
        }

        refreshToken().then(({body: token}) => {
          store.commit(OBTAIN_AUTHENTICATION, token) // 重新获取认证
          for (let req of pendingRequests) {
            req.request.headers.set('Authorization', store.state.auth.header)
            req.resolve(Vue.http(req.request))
          }
        }).catch(() => {
          for (let req of pendingRequests) {
            req.reject()
          }
          logout(true)
        }).finally(() => {
          pendingRequests = []
        })

        return new Promise((resolve, reject) => {
          pendingRequests.push({request, resolve, reject})
        })
      }
    })
  })
}

function logout (overdue = true) {
  if (overdue) {
    alert('用于通信的信标已过期,你必须重新登录!', () => {
      store.commit(CLEAR_AUTHENTICATION)
      if (isWechatBrowser()) {
        window.location.href = getAuthorizeUrl()  // 获取微信认证地址
      } else {
        router.replace({name: 'Login'})
      }
    })
  } else {
    router.replace({name: 'Login'})
  }
}



// WEBPACK FOOTER //
// ./src/api/setup.js